import { Header } from '@/components/layout/Header'
import { Hero } from '@/components/sections/Hero'
import { Pain } from '@/components/sections/Pain'
import { Features } from '@/components/sections/Features'
import { SocialProof } from '@/components/sections/SocialProof'
import { Scarcity } from '@/components/sections/Scarcity'
import { FinalCTA } from '@/components/sections/FinalCTA'
import { Footer } from '@/components/sections/Footer'
import { ExitIntentPopup } from '@/components/ui/ExitIntentPopup'
import { useExitIntent } from '@/hooks/useExitIntent'

export function HomePage() {
  const { showPopup, closePopup } = useExitIntent({ delay: 5000 })

  return (
    <div className="relative min-h-screen">
      {/* Noise Overlay */}
      <div className="noise-overlay" />

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main>
        <Hero />
        <Pain />
        <Features />
        <SocialProof />
        <Scarcity />
        <FinalCTA />
      </main>

      {/* Footer */}
      <Footer />

      {/* Exit Intent Popup */}
      <ExitIntentPopup isOpen={showPopup} onClose={closePopup} />
    </div>
  )
}
